import { apiSlice } from '../apiSlice'

export const registrationApiSlice = apiSlice.injectEndpoints({
	endpoints: (build) => ({
		registration: build.mutation({
			query: (body) => ({
				url: '/users/',
				method: 'POST',
				body,
			})
		})
	})
})

export const {
	useRegistrationMutation
} = registrationApiSlice